import { imgW } from "../lib/api";

// Image plein cadre : 800 px max sur mobile, 1600 px sur grand écran.
export const Pic = ({ src, w = 1600, mw = 800, ...img }) => (
  <picture className="cs-pic">
    <source media="(max-width:767px)" srcSet={imgW(src, mw)} />
    <img src={imgW(src, w)} alt="" {...img} />
  </picture>
);
